import React from 'react';
import RadioImg from 'react-radioimg';
import paypal from './img/c.png';
import credit from './img/cre.png';
import {
    CardElement,
    useStripe, useElements
  } from '@stripe/react-stripe-js';
import './style_payement.css';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from './ChekoutForm';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.


export default class Payment extends React.Component{



    render(){
        const stripePromise = loadStripe('pk_test_51I3RFIAUtt0htw4PU2qMmhqKfqevL1ipRBocupYCKEVNRph808go1jPCZJMkSdMgyE0pEHx5On85Nf6QCAmYDjjv00REHbG91f');
      
            
        
        let yesNoOptions = [
            {
              btnCls: 'btn btn-lg btn-default',
              btnSelCls: 'btn btn-lg btn-primary sel',
              img:'./img/credit_card.jpg',
              
            },
            {
              btnCls: 'btn btn-lg btn-default',
              btnSelCls: 'btn btn-lg btn-primary sel',
              img:'./img/paypal-avis.png',
                val:'yes',
                label:'./img/paypal-avis.png'
            }
            
          ]
        return(

<div className="container" style={{marginTop:"60px"}}>
    <h2>Paiement</h2>
    <p style={{color:"black"}}>Choisissez le type de paiement:</p>
    <br/>    <br/>

    <Elements stripe={stripePromise}>
<CheckoutForm/>
   
    </Elements>



</div>

        )
    }
}